"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfLiffBindMemberModel = instanceOfLiffBindMemberModel;
exports.LiffBindMemberModelFromJSON = LiffBindMemberModelFromJSON;
exports.LiffBindMemberModelFromJSONTyped = LiffBindMemberModelFromJSONTyped;
exports.LiffBindMemberModelToJSON = LiffBindMemberModelToJSON;
exports.LiffBindMemberModelToJSONTyped = LiffBindMemberModelToJSONTyped;
/**
 * Check if a given object implements the LiffBindMemberModel interface.
 */
function instanceOfLiffBindMemberModel(value) {
    if (!('lineId' in value) || value['lineId'] === undefined)
        return false;
    if (!('phone' in value) || value['phone'] === undefined)
        return false;
    return true;
}
function LiffBindMemberModelFromJSON(json) {
    return LiffBindMemberModelFromJSONTyped(json, false);
}
function LiffBindMemberModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'lineId': json['lineId'],
        'lineName': json['lineName'] == null ? undefined : json['lineName'],
        'linePicture': json['linePicture'] == null ? undefined : json['linePicture'],
        'memberName': json['memberName'] == null ? undefined : json['memberName'],
        'phone': json['phone'],
        'email': json['email'] == null ? undefined : json['email'],
    };
}
function LiffBindMemberModelToJSON(json) {
    return LiffBindMemberModelToJSONTyped(json, false);
}
function LiffBindMemberModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'lineId': value['lineId'],
        'lineName': value['lineName'],
        'linePicture': value['linePicture'],
        'memberName': value['memberName'],
        'phone': value['phone'],
        'email': value['email'],
    };
}
